import React, { PropsWithChildren } from 'react'
import { makeStyles } from '@material-ui/core'
import { Button, Infotip, Typography } from 'foundations-library/components'
import StatusChip from './StatusChip'
import EnrollmentEvents from './EnrollmentEvents'
import { EnrollmentType } from '../interface/EnrollmentType'

const jss = (theme) => {
    const { colors } = theme['foundations-library']
    return {
        content: {
            maxWidth: '1000px',
            alignItems: 'center',
            gap: '40px',
            padding: '20px',
            borderRadius: '10px',
            border: `1px solid ${colors.neutral[100]}`,
            margin: '0 auto',
            marginBottom: 40
        },
        titles: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        chip: {
            margin: '15px 0 40px 0'
        },
        mb40: {
            marginBottom: 40
        },
        mb15: {
            marginBottom: 15
        },
        buttonContainer: {
            textAlign: 'right',
            paddingBottom: 40
        },
        infotip: {
            maxWidth: '100%'
        }
    }
}

const useStyles = makeStyles(jss)

interface PropsInterface {
    item: Record<string, unknown>
    titleLeft?: string
    titleRight: string
    enrollmentType: EnrollmentType
    onGoBack(): unknown
}

/**
 *
 */
const Preview = ({
    item,
    children,
    titleLeft = 'Review and Edit',
    titleRight,
    enrollmentType,
    onGoBack
}: PropsWithChildren<PropsInterface>): JSX.Element => {
    const styles = useStyles()
    return <div data-testid='preview-container'>
        <div className={styles.content}>
            <div className={styles.titles}>
                <Typography variant='h5' data-testid='preview-title-left'>{titleLeft}</Typography>
                <Typography variant='h7' data-testid='preview-title-right'>{titleRight}</Typography>
            </div>
            <div className={styles.chip}>
                <Infotip value={item?.latest_event?.description} bottom className={styles.infotip}>
                    <StatusChip
                        status={item.registration_status || item.status}
                        enrollmentType={enrollmentType}
                        showPopover={false}
                        itemsAttached={item.active_did_count || item.campaign_count} // for campaign || for brand
                        data-testid='preview-status-chip'
                    />
                </Infotip>
            </div>
            {children}
            <EnrollmentEvents
                entityType={enrollmentType === EnrollmentType.Brand ? 'brand' : 'campaign'}
                entityId={enrollmentType === EnrollmentType.Brand ? item.csp_brand_id : item.csp_campaign_id}
            />
        </div>
        <div className={styles.buttonContainer}>
            <Button onClick={onGoBack} variant='outlined' color='neutral' data-testid='preview-back-button'>Back</Button>
        </div>
    </div>
}

export default Preview
